import { useStorageBuckets } from "@features/storage/use-storage.hook";
import { Button } from "@shared/ui/button";
import { Card, CardContent } from "@shared/ui/card";
import { BucketsList } from "@widgets/storage/buckets-list";
import { CreateBucketDialog } from "@widgets/storage/create-bucket-dialog";
import { FilesTable } from "@widgets/storage/files-table";
import { FolderPlus, Plus } from "lucide-react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export default function StoragePage() {
	const { buckets, isPending, createBucket, deleteBucket } = useStorageBuckets();
	const [activeBucket, setActiveBucket] = useState("");
	const [dialogOpen, setDialogOpen] = useState(false);

	const selectedBucket = activeBucket || buckets[0]?.name || "";
	const isEmpty = !isPending && buckets.length === 0;

	return (
		<div className="space-y-6 w-full">
			{isEmpty ? (
				<Card>
					<CardContent className="flex flex-col items-center justify-center gap-4 py-20 text-center">
						<div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent text-muted-foreground">
							<FolderPlus className="h-7 w-7" />
						</div>
						<div className="space-y-1">
							<h2 className="text-lg font-semibold">
								<FormattedMessage id="page.storage.empty.title" defaultMessage="No buckets yet" />
							</h2>
							<p className="max-w-sm text-sm text-muted-foreground">
								<FormattedMessage
									id="page.storage.empty.description"
									defaultMessage="Buckets are containers for your files. Create your first bucket to start uploading and managing files."
								/>
							</p>
						</div>
						<Button onClick={() => setDialogOpen(true)}>
							<Plus className="mr-1 h-4 w-4" />
							<FormattedMessage id="page.storage.empty.action" defaultMessage="New bucket" />
						</Button>
					</CardContent>
				</Card>
			) : (
				<section className="grid gap-4 lg:grid-cols-[320px_1fr]">
					<BucketsList
						buckets={buckets}
						isPending={isPending}
						activeBucket={selectedBucket}
						onSelect={setActiveBucket}
						onDelete={deleteBucket}
						onAdd={() => setDialogOpen(true)}
					/>
					{selectedBucket && <FilesTable bucket={selectedBucket} />}
				</section>
			)}

			<CreateBucketDialog open={dialogOpen} onOpenChange={setDialogOpen} onConfirm={createBucket} />
		</div>
	);
}
